import { render, staticRenderFns } from "./ListRetrievals.vue?vue&type=template&id=3247f2a5&scoped=true&"
import script from "./ListRetrievals.vue?vue&type=script&lang=js&"
export * from "./ListRetrievals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3247f2a5",
  null
  
)

export default component.exports